// extracted by mini-css-extract-plugin
module.exports = {"container":"Editor_container__18NZH"};